import React, { useState } from "react";
import api from "../../api";

const CommentForm = ({ postId, onCommentAdded }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isDisabled = loading || !content.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!content.trim()) {
      setError("Le commentaire ne peut pas être vide.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await api.post(`/comments/${postId}`, {
        content: content.trim(),
      });

      if (onCommentAdded) onCommentAdded(response.data);
      setContent("");
    } catch (err) {
      console.error(err);
      if (err.response?.data?.errors) {
        setError(Object.values(err.response.data.errors).flat().join(" "));
      } else {
        setError(err.response?.data?.message || "Erreur lors de l'envoi du commentaire.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-6">
          Laissez un commentaire
        </h2>
        <form onSubmit={handleSubmit} className="bg-gray-900 rounded-lg shadow p-5">
          <div className="mb-4">
            <label htmlFor="commentContent" className="block text-sm font-bold mb-2 text-white">
              Votre commentaire
            </label>
            <textarea
              id="commentContent"
              rows="4"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Partagez votre avis sur ce post..."
              className="w-full py-3 px-4 rounded border border-gray-600 bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"
            />
            <div className="flex justify-between items-center mt-2">
              <p className="text-sm text-gray-400">Soyez respectueux dans votre message.</p>
              <span className="text-sm text-gray-400">{content.length} caractères</span>
            </div>
          </div>

          {error && (
            <div className="mb-4 bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isDisabled}
            className={`text-white font-bold py-2 px-4 rounded transition ${
              isDisabled ? "bg-orange-300 cursor-not-allowed" : "bg-orange-500 hover:bg-orange-700"
            }`}
          >
            {loading ? "Envoi..." : "Envoyer"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CommentForm;